<ng-container *transloco="let t">
  <authority-labs-entity-selector
    [title]="title"
    [crudService]="service"
    [searchFields]="searchFields"
    [optionTpl]="optionTpl"
    [selectedTpl]="selectedTpl"
    [getLabel]="getLabel"
    [optionHeight]="62"
    [optionsSize]="4"
  >
    <ng-template let-entity="entity" #optionTpl>
      <authority-labs-contractor-info
        [contractor]="entity"
      ></authority-labs-contractor-info>
    </ng-template>
    <ng-template let-entity="entity" #selectedTpl>
      <authority-labs-contractor-info
        [contractor]="entity"
      ></authority-labs-contractor-info>
    </ng-template>
  </authority-labs-entity-selector>
</ng-container>
